import { isBoolean } from "lodash";

export { isBoolean };
